import { ThemeColor } from '@/const/color';
import { getPlatform } from '@/utils/url';
import type { ThemeConfig } from '@aplus-frontend/antdv/es/config-provider/context';
const commonToken: ThemeConfig['token'] = {
  borderRadius: 4,
  fontSize: 14,
  sizeStep: 4,
  lineHeightSM: 1.6,
  wireframe: false
};

export const userToken: ThemeConfig['token'] = {
  ...commonToken,
  // 主色
  colorPrimary: ThemeColor.Primary,
  colorPrimaryHover: ThemeColor.PrimaryHover,
  colorPrimaryActive: ThemeColor.PrimaryActive,
  // 字体颜色
  colorTextBase: ThemeColor.TextPrimary,
  colorText: ThemeColor.TextPrimary,
  colorTextSecondary: ThemeColor.TextSecondary,
  colorTextTertiary: ThemeColor.TextTertiary,
  // 各组件 placeholder color
  colorTextPlaceholder: ThemeColor.TextPlaceholder,
  // 边框颜色
  colorBorder: ThemeColor.Border,
  // 分割线颜色
  colorSplit: ThemeColor.Divider,
  // 信息色
  colorInfo: ThemeColor.Blue,
  // 成功色
  colorSuccess: ThemeColor.Green,
  // 错误色
  colorError: ThemeColor.Red,
  // 警告色
  colorWarning: ThemeColor.Orange,
  colorBgContainerDisabled: ThemeColor.PrimaryDisabled,

  wireframe: false,
  colorBgLayout: '#F2F6F9',
  colorBgSpotlight: '#000000cc',
  controlItemBgActive: '#F5F9FF',
  controlItemBgActiveHover: '#EAF2FF',
  colorBorderSecondary: '#E9EDF3'
};

export const adminToken: ThemeConfig['token'] = {
  ...commonToken,
  // 主色
  colorPrimary: '#FB7C34',
  colorPrimaryHover: '#FDB085',
  colorPrimaryActive: '#FC965D',
  colorTextBase: '#333333',
  // colorTextDisabled: '#666666',
  // 字体颜色
  colorText: '#333333',
  colorTextSecondary: '#666666',
  colorTextTertiary: '#999999',
  // 各组件 placeholder color
  colorTextPlaceholder: '#ABB7CC',
  // 边框颜色
  colorBorder: '#D9D9D9',
  // 分割线颜色
  colorSplit: '#E9E9E9',
  // 信息色
  colorInfo: '#1890FF',
  // 成功色
  colorSuccess: '#34b77c',
  // 错误色
  colorError: '#FF4D4F',
  // 警告色
  colorWarning: '#FAAD14',
  colorLink: '#1890FF',
  wireframe: false,
  colorBgLayout: '#FAFAFA',
  colorBgSpotlight: '#000000cc',
  controlItemBgActive: '#f3fbf7',
  controlItemBgActiveHover: '#e6f6ef',
  colorBorderSecondary: '#E9E9E9'
};

export const colorMap = getPlatform() == 'user' ? userToken : adminToken;
